export const SET_CONFIG = "SET_CONFIG";

export function setConfig(payload) {
  return {
    type: SET_CONFIG,
    payload
  };
}
